import { render, staticRenderFns } from "./CompetitionAdminPage.vue?vue&type=template&id=3cc2dd2a&scoped=true"
import script from "./CompetitionAdminPage.vue?vue&type=script&lang=js"
export * from "./CompetitionAdminPage.vue?vue&type=script&lang=js"
import style0 from "./CompetitionAdminPage.vue?vue&type=style&index=0&id=3cc2dd2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc2dd2a",
  null
  
)

export default component.exports